<template>
  <div>
    <PageHeader />
    <ProjInfo :projectInfo="projectInfo" :changelog="changelog" />


    <v-container class="section-block">

        <v-row>
            <v-col class="col-12" no-gutters>
                <v-responsive :aspect-ratio="16/9">
                    <video width="100%" :src="video.tutorial" :poster="images.poster" controls></video>
                </v-responsive>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="col-12 col-sm-6 col-md-4">
                <div class=" group-header">Usage</div>
            </v-col>
            <v-col class="col-12 col-md-8"> </v-col>
            <v-col class="col-12 col-sm-6 col-md-4">

                <h3>Setup</h3>
                <p>
                    After install, open the <b>01 Start Here</b> comp. This will contain a precomp called <b>Adaptive Pill</b> which has a bunch of expressions on it that control how everything looks. Copy this precomp into your working comp(s) to use <b>Adaptive Pill</b>.  
                </p>
            </v-col>
            <v-col class="col-12 col-sm-6 col-md-4">
                <img :src="images.pillCtrls" width="100%" alt="">
            </v-col>
            <v-col class="col-12 col-sm-6 col-md-4">

                <h3>Editable elements</h3>
                <ul>
                    <li><b>Phase change</b> - Add keyframes to create a transition</li> 
                    <li><b>Text states</b> - 5 slots</li> 
                    <li><b>Icon states</b> - 5 slots</li> 
                    <li><b>Alignment</b> - Left, center, right</li> 
                    <li><b>Tiny dot offset</b> - horizontal shift of the tiny dot when icon and text are both set to blank</li> 
                    <li><b>Tiny dot size</b> - 20x20 pixel default</li> 
                    <li><b>Icon/text color</b> - Color of the elements within the pill</li> 
                    <li><b>Pill color</b> - Color of the pill</li> 
                    <li><b>Transition time</b> - Transition time in milliseconds between states</li> 
                    <li><b>Icon size</b> - 60x60 pixels default</li> 
                    <li><b>Pill rounding</b> - default 100%</li> 
                    <li><b>Margin X</b> - margin around the icon and text</li> 
                    <li><b>Margin Y</b> - margin around the icon and text</li> 
                    <li><b>Element margin</b> - margin between icon and text </li> 
                </ul>
            </v-col>
            </v-row>
            
            <v-row>
            <v-col class="col-12 col-sm-6 col-md-4">
                <video width="100%" :src="video.transitions" autoplay loop muted></video>
                <h2>Automatic transitions</h2>
                <p>
                    Transition timing is done programmatically to match the look of visual elements on device. 
                </p>
                <ul>
                    <li>Set keyframes on the <b>Phase change</b> property</li>
                    <li>The <b>Icon</b> and <b>Text</b> selectors will be sampled at these keyframes and used to update content and resize the pill</li>
                    <li>The transition will start 180ms before this time and this value may be edited with the <b>Transition Time</b> property</li>
                    <li>When both Icon and Text selectors are set to <b>Blank</b>, the pill will shrink down to the <b>Tiny dot size</b></li>
                    <li><b>Tiny dot offset</b> will shift horizontally</li>
                </ul>

            </v-col>
            <v-col class="col-12 col-sm-6 col-md-4">
                <video width="100%" :src="video.editText" autoplay loop muted></video>
                <h2>Editing text</h2>
                <p> If you have never worked with Essential Graphics it is easy to get tripped up by how to actually edit the available text fields. </p>
                <p> Right-click the <b>Text field > Edit Value...</b> </p>
                <p> This will open a popup to update the text state. </p>
            </v-col>
            <v-col class="col-12 col-sm-6 col-md-4">
                <video width="100%" :src="video.iconReplace" autoplay loop muted></video>
                <h2>Updating icons</h2>
                <p> Replace icons by dragging new art into these slots. It will be sized correctly to the <b>Icon size</b> property.</p>
                <p> Essential Graphics precomps are special and footage elements may be replaced by dragging another precomp or still. It's pretty fancy. </p>
            </v-col>
        </v-row>



    <v-row>
    <v-col class="col-12 col-sm-6 col-md-4">
        <div class=" group-header">Troubleshooting</div>
    </v-col>
    <v-col class="col-12 col-md-8"> </v-col>
    <v-col class="col-12 col-md-4">
        <h3>Missing icon fields</h3>
        <p>Sometimes after importing the <b>AdptivePill.aep</b> project, there is a visual glitch where the icon fields are not visible. To restore these:</p>
        <ol>
            <li>Open Window > Essential Graphics</li>
            <li> Select the Primary comp: Adaptive pill </li>
            <li>Select one of the Icon fields</li>
            <li>Delete</li>
            <li>CMD/Ctrl+Z to undo this delete</li>
            <li>The fields should now be visible</li>
        </ol>
    </v-col>
    <v-col class="col-12 col-md-6">
        <video width="100%" :src="video.missingFields" autoplay loop muted></video>
    </v-col>

    <!-- <v-col class="col-12 col-md-6">
        <img src="/images/install/ProjectImport.gif" width="100%" alt="">
    </v-col> -->
    </v-row>
    
    
    <v-row>
    <v-col class="col-12 col-sm-6 col-md-4">
        <div class=" group-header" id="install">Install</div>
    </v-col>
    <v-col class="col-12 col-md-8"> </v-col>
    <v-col class="col-12 col-md-4">
        <h3>This is a project file so there is nothing to install</h3>
        <p>Simply drag the <b>AdaptivePill.aep</b> file into your current After Effects file and start using it.</p>
    </v-col>
    <v-col class="col-12 col-md-6">
        <img src="/images/install/ProjectImport.gif" width="100%" alt="">
    </v-col>
    </v-row>
    </v-container>

    <Changelog :changelog="changelog" /> 
    
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'conclave',
  components: {
  },
  data: () => ({
        images: {
            poster: require('../assets/images/AdaptivePill-poster.jpg'),
            pillCtrls: require('../assets/images/PillCtrls.jpg'),
            // transitions: require('../assets/images/Dotkit_transitions.png'),
            // newLayer: require('../assets/images/Dotkit-NewLayer.jpg'),
            // addState: require('../assets/images/Dotkit-AddState.jpg'),
            // removeNearest: require('../assets/images/Dotkit-RemoveNearest.jpg'),
        },
        video: {
            tutorial: require('../assets/video/AdaptivePill-tutorial.mp4'),
            missingFields: require('../assets/video/Pill-MissingFields.mp4'),
            transitions: require('../assets/video/Pill-Transitions.mp4'),
            editText: require('../assets/video/Pill-TextEdit.mp4'),
            iconReplace: require('../assets/video/Pill-IconReplacement.mp4'),
        },
      projectInfo: {
          name: 'Adaptive Pill',
          subtitle: 'The rounded rectangle of your dreams',
        //   download: '/download/Conclave_0.4.0.zxp',
        //   version: '0.4',
        //   updated: 'Apr 9, 2020',
          about: `As simple as it is to create a rounded rectangle in CSS or Figma that's adjusted by the content inside if it, this is not easy in Ae.
          
          Edit the text or icon and the pill resizes. Set keyframes to switch between states and the system takes care of the rest. `
      },
      changelog: [
            {
                version: '1.2.0',
                date: 'Dec 08, 2022',
                added: [
                    'Tiny dot settings',
                    'Icon/text color',
                ],
                changed: [
                    'Transitions now controlled by Phase Change keyframes',
                    'Rewritten expressions for speed and simplicity'
                ]
            },
            {
                version: '1.0.0',
                date: 'Oct 12, 2022',
                comment: [
                    'Initial release',
                ],
            },
        ],
  }),
}
</script>